// var λ = require('contra');
import * as contra from 'contra'

import MicroModal from 'micromodal'
import { hideOthers } from 'aria-hidden'
import * as focusTrap from 'focus-trap'
import key from 'keymaster'
import Parvus from 'parvus'
import Cookies from 'js-cookie'
import * as jQuery from 'jquery'

import 'parvus/dist/css/parvus.css'

window.Parvus = Parvus
window.hideOthers = hideOthers
window.key = key
window.contra = contra
window.Cookies = Cookies
window.focusTrap = focusTrap
window.jQuery = jQuery

import './overrides.less'
